<template>
    <div class="make-offer-container">
        <Offer :opportunity="opportunityInfo" />
        <div class="make-offer">
            <p class="title">You Offer</p>
            <div class="fields">
                <div class="fields-top">
                    <div class="proposed-payout">
                        <label for="proposed-payout">Proposed Payout *</label>
                        <input
                            v-model="$v.userData.makeOffer.counter_offer.$model"
                            type="number"
                            class="proposed-payout-input"
                            placeholder="$150"
                        />
                        <span
                            v-if="
                                $v.userData.makeOffer.counter_offer.$dirty &&
                                $v.userData.makeOffer.counter_offer.$model
                            "
                            class="dollar-sign"
                        >
                            $
                        </span>
                        <p
                            v-if="
                                $v.userData.makeOffer.counter_offer.$dirty &&
                                (!$v.userData.makeOffer.counter_offer.required ||
                                    !$v.userData.makeOffer.counter_offer.minValue)
                            "
                            class="error-msg"
                        >
                            Please enter a payout amount.
                        </p>
                    </div>
                    <div class="set-duration">
                        <label for="set-duration">Set Duration (min) *</label>
                        <input
                            v-model="$v.userData.makeOffer.counter_offer_duration.$model"
                            @input="onDurationInput"
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            class="set-duration-input"
                            placeholder="Eg. 60"
                        />
                        <p
                            v-if="
                                $v.userData.makeOffer.counter_offer_duration.$dirty &&
                                !$v.userData.makeOffer.counter_offer_duration.required
                            "
                            class="error-msg"
                        >
                            Please enter a set duration.
                        </p>
                        <p
                            v-if="
                                $v.userData.makeOffer.counter_offer_duration.$dirty &&
                                !$v.userData.makeOffer.counter_offer_duration.between
                            "
                            class="error-msg"
                        >
                            Please enter between 5 and 1000 minutes.
                        </p>
                    </div>
                    <div class="set-start">
                        <TimeSelector
                            label="Set Start Time *"
                            :inputTime.sync="userData.makeOffer.start_avail_time"
                            :inputFormat.sync="userData.makeOffer.start_avail_format"
                        />
                    </div>
                </div>
                <textarea
                    name="extra_requirements"
                    v-model="$v.userData.makeOffer.extra_requirements.$model"
                    class="message"
                    placeholder="Add details to your offer in a message"
                ></textarea>
                <p
                    v-if="
                        $v.userData.makeOffer.extra_requirements.$dirty &&
                        !$v.userData.makeOffer.extra_requirements.maxLength
                    "
                    class="error-msg"
                >
                    Please enter less than 1000 characters.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, between, minValue, maxLength } from 'vuelidate/lib/validators'
    import TimeSelector from '@/components/ui/time-selector/TimeSelector.vue'
    import Offer from './parts/Offer.vue'

    export default {
        name: 'MakeOffer',
        props: {
            opportunityInfo: {
                type: Object,
                required: false
            },
            userData: {
                type: Object,
                required: true
            },
            validation: {
                type: Object,
                required: false
            }
        },
        components: {
            Offer,
            TimeSelector
        },
        validations: {
            userData: {
                makeOffer: {
                    counter_offer: { required, minValue: minValue(0) },
                    counter_offer_duration: {
                        required,
                        between: between(5, 1000)
                    },
                    extra_requirements: {
                        maxLength: maxLength(1000)
                    }
                }
            }
        },
        watch: {
            $v: {
                handler: function (validation) {
                    this.$emit('update:validation', validation)
                },
                immediate: true
            }
        },
        methods: {
            onDurationInput() {
                this.$nextTick(() => {
                    this.$v.userData.makeOffer.counter_offer_duration.$model =
                        this.$v.userData.makeOffer.counter_offer_duration.$model.replace(
                            /[^0-9]/g,
                            ''
                        )
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .make-offer-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 40px;

        .make-offer {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 16px;

            .title {
                color: #dedede;
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
            .fields {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                gap: 16px;

                .fields-top {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    gap: 16px;

                    @media screen and (max-width: 768px) {
                        flex-wrap: wrap;
                    }

                    .proposed-payout,
                    .set-duration,
                    .set-start {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-start;

                        @media screen and (max-width: 768px) {
                            width: 89vw;
                        }

                        label {
                            padding: 4px 2px;
                            color: #acacac;
                            @include base-font-12;
                            line-height: 135%;
                            letter-spacing: 0.12px;
                            text-wrap: nowrap;
                        }

                        input {
                            width: 100%;
                            border-radius: 8px;
                            border: 1px solid #8b8b8b;
                            background: rgba(255, 255, 255, 0);
                            padding: 10px 12px;
                            color: #dedede;
                            text-overflow: ellipsis;
                            @include base-font-16;
                            line-height: 125%;
                            -moz-appearance: textfield;
                            appearance: textfield;
                        }
                        input::-webkit-outer-spin-button,
                        input::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                            margin: 0;
                        }
                        input::placeholder {
                            overflow: hidden;
                            color: #646464;
                            text-overflow: ellipsis;
                            @include base-font-16;
                            line-height: 125%;
                        }
                        .proposed-payout-input {
                            padding-left: 17px;

                            @media screen and (max-width: 768px) {
                                max-width: 112px;
                            }
                        }
                        .error-msg {
                            position: absolute;
                            bottom: -13px;
                            color: #ed3c0d;
                            font-family: Instrument Sans;
                            font-size: 8px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 130%;
                            letter-spacing: 0.14px;
                            text-wrap: nowrap;
                        }
                        .dollar-sign {
                            position: absolute;
                            left: 7px;
                            top: 34px;
                            color: #dedede;
                            text-overflow: ellipsis;
                            @include base-font-16;
                            line-height: 125%;
                        }
                    }
                    .set-duration,
                    .set-start {
                        @media screen and (max-width: 768px) {
                            flex-basis: 160px;
                        }
                    }
                }
                .message {
                    padding: 10px 12px;
                    width: 100%;
                    background: none;
                    border-radius: 8px;
                    border: 1px solid #8b8b8b;
                    height: 122px;
                    color: #dedede;
                    text-overflow: ellipsis;
                    @include base-font-16;
                    line-height: 125%;
                    resize: none;
                }
                .message::placeholder {
                    overflow: hidden;
                    color: #646464;
                    text-overflow: ellipsis;
                    @include base-font-16;
                    line-height: 125%;
                }
                .error-msg {
                    color: #ed3c0d;
                    font-family: Instrument Sans;
                    font-size: 8px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                    text-wrap: nowrap;
                }
            }
        }
    }
</style>
